import axios from 'axios';

import apiService from '../../../services/api.service';
import { URL_CONSTANTS } from '../../../constants/urlConstants';
import { REACT_APP_BULLETIN_BASEURL } from '../../../constants/envConstants';

export const getActiveBulletin = async (homepageOrTopBar, date) => {
  try {
    const response = await apiService.getWithDiffBaseUrl(
      `/api/bulletin/active-bulletin/${homepageOrTopBar}/${date}`,
      undefined,
      REACT_APP_BULLETIN_BASEURL
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getClientListForConfig = async () => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/client-list`
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};
